import { track } from '@gd/tracking';
import { jslog } from '@gd/jslog';
import convertGDC from './convertGDC';
import { events } from '@gd/event-bus';
import Env from './env';
import ZoomDetector from './ZoomDetector';
import { Storage } from '@gd/storage';
/**
 * Register all modules on the GD context
 *
 * (the $toast module is registering by there own on GD.$toast - in future we should avoid self registering and do it only in here)
 */
var GD = /** @class */ (function () {
    function GD() {
        var _this = this;
        this.$track = track;
        this.$jslog = jslog;
        this.env = new Env();
        this.convertGDC = convertGDC;
        this.zoomDetector = new ZoomDetector();
        this.storage = new Storage();
        /**
         * @deprecated please emit the event by your own
         */
        this.shop = {
            navigateTo: function () {
                _this.events.$emit('deposit');
            },
        };
        this.events = events;
    }
    return GD;
}());
export default GD;
export { ZoomDetector, Env };
//# sourceMappingURL=index.js.map